module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-03.223f370d.jpg";